import React, { useEffect } from 'react';
import { BaseActions } from 'store/actionCreators';
export const pmsStartProject = 'startProject';
export const pmsViewThumbnail = 'viewThumbnail';

function SystemStorageChecker() {
  const { ipcRenderer } = window;

  useEffect(() => {
    if (!ipcRenderer) return;
    ipcRenderer.send('installedAppList', {});
    ipcRenderer.on('installedAppListRes', (e: any, data: any) => {
      console.log('HDS] SystemStorageChecker _____ ', data.appList);
      BaseActions.set_installed_applist(data.appList);
    });
  }, []);
  return <></>;
}

export default SystemStorageChecker;
